exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form{padding:5px}.button-save{margin-left:20px}", ""]);

// exports
